import {createRoute, redirect} from "@tanstack/react-router"
import {rootRoute, RouteContext} from "@/routing/router"
import PortalLayout from "@/components/layout/layout.portal"
import NewsPage from "@/pages/portal/news"
import ProgramChangesPage from "@/pages/portal/program-changes"
import {PAGE_ADMIN_EMPLOYEES, PAGE_NEWS, PAGE_RESOURCES_CHANGELOGS, pages} from "@/page-definitions"
import NotFound404Portal from "@/pages/portal/404-not-found-portal"
import EmployeesPage from "@/pages/portal/employees"

export const portalRoute = createRoute({
    path: "/portal",
    getParentRoute: () => rootRoute,
    beforeLoad: async ({context}: { context: RouteContext }) => {
        if (!context.auth || (!context.auth.isLoading && !context.auth.token))
            throw redirect({
                to: "/auth/sign-in"
            })
    },
    notFoundComponent: NotFound404Portal,
    component: PortalLayout
})

export const newsRoute = createRoute({
    path: "/",
    staticData: {
        pageInfo: pages[PAGE_NEWS]
    },
    getParentRoute: () => portalRoute,
    component: () => <NewsPage />
})

export const changesRoute = createRoute({
    path: "/resources/program-changes",
    staticData: {
        pageInfo: pages[PAGE_RESOURCES_CHANGELOGS]
    },
    getParentRoute: () => portalRoute,
    component: ProgramChangesPage,
})

export const refKeyChangesRoute = createRoute({
    path: "/resources/program-changes/$refKey",
    staticData: {
        pageInfo: pages[PAGE_RESOURCES_CHANGELOGS]
    },
    getParentRoute: () => portalRoute,
    component: ProgramChangesPage
})

export const employeesRoute = createRoute({
    path: "/admin/employees",
    staticData: {
        pageInfo: pages[PAGE_ADMIN_EMPLOYEES]
    },
    getParentRoute: () => portalRoute,
    component: EmployeesPage
})
